<template>
    <div class="btt_container" id="btt_button" @click="toPageTop">
        <div class="arrow_container"><p>&#x25B2;</p></div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            text: "Vue3 component."
        }
    },
    mounted(){
        window.onscroll = () => { this.trackMovement() }
    },
    methods: {
        trackMovement(){
            const buttonToTop = document.getElementById("btt_button");
            if (document.body.scrollTop > 1200 || document.documentElement.scrollTop > 1200) {
                buttonToTop.classList.add('visible');
            } else {
                buttonToTop.classList.remove('visible');
            }
        },

        toPageTop(){
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    }
}
</script>
<style scoped lang="scss">

    .btt_container{
        display: inline-block;
        background-color: #ED1163;
        width: 50px;
        height: 50px;
        text-align: center;
        border-radius: 4px;
        position: fixed;
        bottom: 30px;
        border: 1px solid transparent;
        right: 30px;
        transition: background-color .3s, opacity .5s, visibility .5s;
        opacity: 0;
        visibility: hidden;
        z-index: 1000;
        color: black;

        cursor: pointer;

        &:hover{
            background-color: black;
            border-color: #ED1163;
            color: #ED1163;

            .arrow_container{
                p{
                    color: white;
                    transform: scale(1.1);
                    animation: updown 0.9s infinite;
                    border-color: white;
                }
            }
        }

        .arrow_container{
            p{
                position: relative;
                display: block;
            }
        }

        &.visible{
            opacity: 1;
            visibility: visible;
        }
    }

    @keyframes updown {
        0%   {top: 0;}
        50%  {top: -8px;}
        100% {top: 0;}
    }

</style>